let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2tMjx")).then(() => parcelRequire('6ec22'));